module.exports = __webpack_public_path__ + "img/cause4Orange.32d0ec4d.png";